import React from "react";

import AddressCell from "./AddressCell";
import BoolCell from "./BoolCell";
import DateCell from "./DateCell";
import DateTimeCell from "./DateTimeCell";
import FileCell from "./FileCell";
import NumberCell from "./NumberCell";
import SacramentChurch from "./SacramentFields/SacramentChurch";
import SelectListCell from "./SelectListCell";
import SignupItemsCell from "./SignupItemsCell";
import TextCell from "./TextCell";
import { CELL_TYPES, getCellType, getValueParser } from "./conf";

// TODO verify that the props destructure & spread does not break memoization
export default function DynamicCell({ columnType, value, ...props }) {
  const parseValue = getValueParser(columnType);

  const cellProps = {
    ...props,
    rawValue: value,
    value: parseValue(value), // will be object for file types
  };

  switch (getCellType(columnType)) {
    case CELL_TYPES.BOOL:
      return <BoolCell {...cellProps} />;
    case CELL_TYPES.TEXT:
      return <TextCell {...cellProps} />;
    case CELL_TYPES.NUMBER:
      return <NumberCell {...cellProps} />;
    case CELL_TYPES.DATE:
      return <DateCell {...cellProps} />;
    case CELL_TYPES.DATE_TIME:
      return <DateTimeCell {...cellProps} />;
    case CELL_TYPES.ADDRESS:
      return <AddressCell {...cellProps} />;
    case CELL_TYPES.SELECT_LIST:
      return <SelectListCell {...cellProps} />;
    case CELL_TYPES.SIGNUP_ITEMS:
      return <SignupItemsCell {...cellProps} />;
    case CELL_TYPES.FILE:
      return <FileCell {...cellProps} />;
    case CELL_TYPES.SACRAMENT_CHURCH:
      return <SacramentChurch {...cellProps} />;
    default:
      // Useful for debugging when implementing new columns
      // console.warn(
      //   "We're trying to render a Cell whose Type we do not know how to handle: ",
      //   columnType
      // );
      // console.info("DynamicCell.columnType: ", columnType);
      // console.info("DynamicCell.value: ", value);
      return null;
  }
}
